













































import commerceKind from '@/store/types/commerceKind';
import commerce from '@/store/types/commerce';

import { AxiosError, AxiosResponse } from 'axios';
import { TeipNotifications } from '@/util/teipNotifications';
import { CompanyParams } from '@/store/interfaces/company';
import { Route } from 'vue-router';
import company from '@/store/types/company';
import root from '@/store/types/root';
import NewCommerceForm from '@/components/commerce/newCommerce/newCommerceForm.vue';
import uploadimage from '@/store/types/uploadimage';
import { navLink } from '@/ts/navegationLinks';
import { apiErrors } from '@/ts/apiErrors';
import { responseDataPagination } from '@/store/interfaces/json-api/generics';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Vue from 'vue';

declare type BlobImage = {
  blob_signed_id: string;
  headers: {
    'Content-Disposition': string;
    'Content-MD5': string;
    'Content-Type': string | null;
  };
  url: string;
};

declare type dataToSend = {
  company_id: string;
  data: unknown;
};

declare type commerceInfo = {
  company_id: string;
  with_commerce_id: string;
  logo: string;
  banner: string;
  merchant: string;
};

export default Vue.extend({
  name: 'NewCommerce',
  components: {
    NewCommerceForm,
  },
  beforeRouteLeave(to: Route, from: Route, next) {
    if (to.name !== 'new') {
      this.$data.model.commerce_id = '';
      this.$store.commit(
        `commerceModule/${commerce.mutations.SET_EMPTY_NEW_COMMERCE_PARAMS}`
      );
    }
    next();
  },
  data: () => ({

    newCommerceKey: 1,
    model: {},
    clean: false,
    loading: true,
    infoLogo: null,
    infoBanner: null,
    infoLogoMerchant: null,
    showInputCompany: true,
    company_name: '',
    buttonMessage: '', // assigned in created
    navlink: [
      {
        name: '', // Assigned in created
        active: false,
        to: '/commerce/partners',
      },
      {
        name: '', // Assigned in created
        active: true,
      }
    ] as navLink[],
    errors: [],
    sendingData: false,
  }),
  computed: {
    ...mapGetters({
      getProcess: root.getters.GET_START_PROCESS,
      getCommerceKindList: `commerceModule/commerceKind/${commerceKind.getters.GET_COMMERCE_KIND}`,
      getCompanyList: `companyModule/${company.getters.GET_COMPANY}`,
      getNewCompanyCommerce: `commerceModule/${commerce.getters.GET_NEW_COMMERCE_PARAMS}`,
      getCommerceList: `commerceModule/${commerce.getters.GET_COMMERCES}`,
      getSingleCompany: `companyModule/${company.getters.GET_SINGLE_COMPANY}`,
    }),
  },
  async created() {
    this.buttonMessage = `Guardar ${this.$t('menu.commerce.singular.informal')}`;
    this.navlink[0].name = `${this.$t('menu.commerce.plural.formal')} afiliados`;
    this.navlink[1].name = `Nuevo ${this.$t('menu.commerce.singular.informal')}`;

    await this.initConfig();
  },
  methods: {
    ...mapActions({
      saveImage: `uploadImage/${uploadimage.actions.UPLOAD_IMAGE}`,
      commerceKindList: `commerceModule/commerceKind/${commerceKind.actions.LIST_COMMERCE_KIND}`,
      saveCommerce: `commerceModule/${commerce.actions.SAVE_COMMERCE}`,
      singleCompanyAction: `companyModule/${company.actions.SINGLE_COMPANY}`,
      saveImagesForCommerce: `uploadImage/${uploadimage.actions.UPDATE_COMMERCE_BANNER}`,
    }),
    ...mapMutations({
      setNewCompanyParams: `commerceModule/${commerce.mutations.SET_NEW_COMMERCE_PARAMS}`,
    }),

    async initConfig(): Promise<void> {
      this.$data.model = this.getNewCompanyCommerce;
      const company_id = this.$route.params.company_id;

      await this.commerceKindList();

      if (company_id) {
        this.$data.company_id = company_id;
        this.$data.showInputCompany = false;
        let company = (this.getCompanyList as responseDataPagination<CompanyParams>).data.filter(
          (company) => company.id === company_id
        )[0];

        if (company === undefined || company == null) {
          await this.singleCompanyAction(company_id);
          company = this.getSingleCompany;
        }

        this.$data.navlink[0].name = company.business_name;
        this.$data.navlink[0].to = `/commerce/company/${company_id}/comercios#comercios`;
        this.$data.company_name = `a ${company.business_name}`;
        this.$data.buttonMessage = `Asignar ${this.$t(
          'menu.commerce.singular.informal'
        )} a ${company.business_name}`;
      }
      this.$data.loading = false;
    },

    firstFormSubmit(commerceInfo: commerceInfo): void {
      this.$data.sendingData = true;
      const { merchant, banner, logo, with_commerce_id, company_id, } =
      commerceInfo;

      const notification = new TeipNotifications();
      const data = Object.assign({}, this.$data.model);
      if (!with_commerce_id) {
        delete data.commerce_id;
      } else {
        delete data.commerce;
        delete data.status;
        delete data.tip_percentage;
      }
      const dataToSend: dataToSend = {
        company_id,
        data: data,
      };

      const infoBanner: BlobImage = this.$data.infoBanner;
      const infoMerchant: BlobImage = this.$data.infoLogoMerchant;
      const infoLogo: BlobImage = this.$data.infoLogo;
      const uploadLogo = {
        data: infoLogo,
        currentFile: logo,
      };
      const uploadBanner = {
        data: infoBanner,
        currentFile: banner,
      };
      const uploadMerchantLogo = {
        data: infoMerchant,
        currentFile: merchant,
      };
      if (!with_commerce_id) {
        const logo = this.saveImage(uploadLogo);
        const banner = this.saveImage(uploadBanner);
        let promisesTrigger = [logo, banner];

        if (uploadMerchantLogo.currentFile !== '') {
          const merchant = this.saveImage(uploadMerchantLogo);
          promisesTrigger = [logo, banner, merchant];
        }

        Promise.all(promisesTrigger)
          .then(() => {
            this.sendDataForSaveCommerce(
              dataToSend,
              `${this.$t(
                'menu.commerce.singular.formal'
              )} guardado exitosamente.`,
              (result: AxiosResponse) => {
                const commerce_id: string = result.data.data.commerce.id;
                const saveLogo = this.saveImagesForCommerce({
                  data: {
                    logo: infoLogo.blob_signed_id,
                  },
                  commerce_id,
                });
                const saveBanner = this.saveImagesForCommerce({
                  data: {
                    banner: infoBanner.blob_signed_id,
                  },
                  commerce_id,
                });

                let registerImagesTrigger = [saveLogo, saveBanner];
                if (uploadMerchantLogo.currentFile !== '') {
                  const saveMerchant_logo = this.saveImagesForCommerce({
                    data: {
                      merchant_logo: infoMerchant.blob_signed_id,
                    },
                    commerce_id,
                  });
                  registerImagesTrigger = [
                    saveLogo,
                    saveBanner,
                    saveMerchant_logo
                  ];
                }

                Promise.all(registerImagesTrigger);
              }
            );
          })
          .catch(() => {
            this.$data.sendingData = false;
            notification.warning('Ha ocurrido un error al subir la imágen');
          });
      } else {
        this.sendDataForSaveCommerce(
          dataToSend,
          `${this.$t('menu.commerce.singular.formal')} asignado correctamente`
        );
      }
    },

    sendDataForSaveCommerce(
      dataToSend: dataToSend,
      message: string,
      callback?: (res: AxiosResponse) => void
    ): void {
      const notification = new TeipNotifications();
      this.saveCommerce(dataToSend)
        .then((result: AxiosResponse) => {
          this.$data.processing = false;
          this.$data.clean = true;
          this.$data.model.commerce_id = '';
          notification.success(message);
          this.$data.newCommerceKey++;
          if (callback) callback(result);
        })
        .catch((err: AxiosError) => {
          if (err.response?.status === 422) {
            if (
              err.response.data.error.commerce_id &&
            err.response.data.error.commerce_id.includes('ya está en uso')
            ) {
              notification.warning(
                `Este ${this.$t(
                  'menu.commerce.singular.informal'
                )} ya está asignado a la ${this.$t(
                  'menu.company.singular.informal'
                )}.`
              );
            }

            const errorsServer: apiErrors = err.response.data;
            const errorsServerKeys: string[] = [];
            Object.keys(errorsServer.error).forEach((e) => {
              if (e.split('.').length > 1) {
                errorsServerKeys.push(e.split('.')[1]);
              } else {
                errorsServerKeys.push(e.split('.')[0]);
              }
            });

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const showErrors: any = [];
            Object.entries(errorsServer.error).forEach(([, value], position) => {
              showErrors[`${errorsServerKeys[position]}`] = value;
            });
            this.$data.errors = showErrors;
          } else {
            notification.warning(
              `Ha ocurrido un error al crear el ${this.$t(
                'menu.commerce.singular.informal'
              )}`
            );
          }
        })
        .finally(() => {
          this.$data.sendingData = false;
          this.$data.clean = false;
        });
    },

    infoLogoUpload(info: BlobImage): void {
      this.$data.infoLogo = info;
    },

    infoBannerUpload(info: BlobImage): void {
      this.$data.infoBanner = info;
    },

    infoLogoMerchantUpload(info: BlobImage): void {
      this.$data.infoLogoMerchant = info;
    },
  },
});

// @Component({
//   name: 'NewCommerce',
//   components: {
//     NewCommerceForm,
//   },
//   beforeRouteLeave(to: Route, from: Route, next) {
//     if (to.name !== 'new') {
//       this.$data.model.commerce_id = '';
//       this.$store.commit(
//         `commerceModule/${commerce.mutations.SET_EMPTY_NEW_COMMERCE_PARAMS}`
//       );
//     }
//     next();
//   },
// })
// class NewCommerce extends Vue {
//   data(): data {
//     return {
//       newCommerceKey: 1,
//       model: {},
//       clean: false,
//       loading: true,
//       infoLogo: null,
//       infoBanner: null,
//       infoLogoMerchant: null,
//       showInputCompany: true,
//       company_name: '',
//       buttonMessage: `Guardar ${this.$t('menu.commerce.singular.informal')}`,
//       navlink: [
//         {
//           name: `${this.$t('menu.commerce.plural.formal')} afiliados`,
//           active: false,
//           to: '/commerce/partners',
//         },
//         {
//           name: `Nuevo ${this.$t('menu.commerce.singular.informal')}`,
//           active: true,
//         }
//       ],
//       errors: [],
//       sendingData: false,
//     };
//   }

//   async created(): Promise<void> {
//     await this.initConfig();
//   }

//   async initConfig(): Promise<void> {
//     this.$data.model = this.getNewCompanyCommerce;
//     const company_id = this.$route.params.company_id;

//     await this.commerceKindList();

//     if (company_id) {
//       this.$data.company_id = company_id;
//       this.$data.showInputCompany = false;
//       let company = this.getCompanyList.data.filter(
//         (company) => company.id === company_id
//       )[0];

//       if (company === undefined || company == null) {
//         await this.singleCompanyAction(company_id);
//         company = this.getSingleCompany;
//       }

//       this.$data.navlink[0].name = company.business_name;
//       this.$data.navlink[0].to = `/commerce/company/${company_id}/comercios#comercios`;
//       this.$data.company_name = `a ${company.business_name}`;
//       this.$data.buttonMessage = `Asignar ${this.$t(
//         'menu.commerce.singular.informal'
//       )} a ${company.business_name}`;
//     }
//     this.$data.loading = false;
//   }

//   firstFormSubmit(commerceInfo: commerceInfo): void {
//     this.$data.sendingData = true;
//     const { merchant, banner, logo, with_commerce_id, company_id, } =
//       commerceInfo;

//     const notification = new TeipNotifications();
//     const data = Object.assign({}, this.$data.model);
//     if (!with_commerce_id) {
//       delete data.commerce_id;
//     } else {
//       delete data.commerce;
//       delete data.status;
//       delete data.tip_percentage;
//     }
//     const dataToSend: dataToSend = {
//       company_id,
//       data: data,
//     };

//     const infoBanner: BlobImage = this.$data.infoBanner;
//     const infoMerchant: BlobImage = this.$data.infoLogoMerchant;
//     const infoLogo: BlobImage = this.$data.infoLogo;
//     const uploadLogo = {
//       data: infoLogo,
//       currentFile: logo,
//     };
//     const uploadBanner = {
//       data: infoBanner,
//       currentFile: banner,
//     };
//     const uploadMerchantLogo = {
//       data: infoMerchant,
//       currentFile: merchant,
//     };
//     if (!with_commerce_id) {
//       const logo = this.saveImage(uploadLogo);
//       const banner = this.saveImage(uploadBanner);
//       let promisesTrigger = [logo, banner];

//       if (uploadMerchantLogo.currentFile !== '') {
//         const merchant = this.saveImage(uploadMerchantLogo);
//         promisesTrigger = [logo, banner, merchant];
//       }

//       Promise.all(promisesTrigger)
//         .then(() => {
//           this.sendDataForSaveCommerce(
//             dataToSend,
//             `${this.$t(
//               'menu.commerce.singular.formal'
//             )} guardado exitosamente.`,
//             (result: AxiosResponse) => {
//               const commerce_id: string = result.data.data.commerce.id;
//               const saveLogo = this.saveImagesForCommerce({
//                 data: {
//                   logo: infoLogo.blob_signed_id,
//                 },
//                 commerce_id,
//               });
//               const saveBanner = this.saveImagesForCommerce({
//                 data: {
//                   banner: infoBanner.blob_signed_id,
//                 },
//                 commerce_id,
//               });

//               let registerImagesTrigger = [saveLogo, saveBanner];
//               if (uploadMerchantLogo.currentFile !== '') {
//                 const saveMerchant_logo = this.saveImagesForCommerce({
//                   data: {
//                     merchant_logo: infoMerchant.blob_signed_id,
//                   },
//                   commerce_id,
//                 });
//                 registerImagesTrigger = [
//                   saveLogo,
//                   saveBanner,
//                   saveMerchant_logo
//                 ];
//               }

//               Promise.all(registerImagesTrigger);
//             }
//           );
//         })
//         .catch(() => {
//           this.$data.sendingData = false;
//           notification.warning('Ha ocurrido un error al subir la imágen');
//         });
//     } else {
//       this.sendDataForSaveCommerce(
//         dataToSend,
//         `${this.$t('menu.commerce.singular.formal')} asignado correctamente`
//       );
//     }
//   }

//   sendDataForSaveCommerce(
//     dataToSend: dataToSend,
//     message: string,
//     callback?: (res: AxiosResponse) => void
//   ): void {
//     const notification = new TeipNotifications();
//     this.saveCommerce(dataToSend)
//       .then((result: AxiosResponse) => {
//         this.$data.processing = false;
//         this.$data.clean = true;
//         this.$data.model.commerce_id = '';
//         notification.success(message);
//         this.$data.newCommerceKey++;
//         if (callback) callback(result);
//       })
//       .catch((err: AxiosError) => {
//         if (err.response?.status === 422) {
//           if (
//             err.response.data.error.commerce_id &&
//             err.response.data.error.commerce_id.includes('ya está en uso')
//           ) {
//             notification.warning(
//               `Este ${this.$t(
//                 'menu.commerce.singular.informal'
//               )} ya está asignado a la ${this.$t(
//                 'menu.company.singular.informal'
//               )}.`
//             );
//           }

//           const errorsServer: apiErrors = err.response.data;
//           const errorsServerKeys: string[] = [];
//           Object.keys(errorsServer.error).forEach((e) => {
//             if (e.split('.').length > 1) {
//               errorsServerKeys.push(e.split('.')[1]);
//             } else {
//               errorsServerKeys.push(e.split('.')[0]);
//             }
//           });

//           // eslint-disable-next-line @typescript-eslint/no-explicit-any
//           const showErrors: any = [];
//           Object.entries(errorsServer.error).forEach(([, value], position) => {
//             showErrors[`${errorsServerKeys[position]}`] = value;
//           });
//           this.$data.errors = showErrors;
//         } else {
//           notification.warning(
//             `Ha ocurrido un error al crear el ${this.$t(
//               'menu.commerce.singular.informal'
//             )}`
//           );
//         }
//       })
//       .finally(() => {
//         this.$data.sendingData = false;
//         this.$data.clean = false;
//       });
//   }

//   infoLogoUpload(info: BlobImage): void {
//     this.$data.infoLogo = info;
//   }

//   infoBannerUpload(info: BlobImage): void {
//     this.$data.infoBanner = info;
//   }

//   infoLogoMerchantUpload(info: BlobImage): void {
//     this.$data.infoLogoMerchant = info;
//   }

//   @Getter(root.getters.GET_START_PROCESS) getProcess!: boolean;
//   // MODULES
//   @Action(`uploadImage/${uploadimage.actions.UPLOAD_IMAGE}`)
//   saveImage!: VuexFunction;

//   @Action(
//     `commerceModule/commerceKind/${commerceKind.actions.LIST_COMMERCE_KIND}`
//   )
//   commerceKindList!: VuexFunction;

//   @Action(`commerceModule/${commerce.actions.SAVE_COMMERCE}`)
//   saveCommerce!: VuexFunction;

//   @Getter(
//     `commerceModule/commerceKind/${commerceKind.getters.GET_COMMERCE_KIND}`
//   )
//   getCommerceKindList!: responseDataPagination<CommerceKindParams>;

//   @Getter(`companyModule/${company.getters.GET_COMPANY}`)
//   getCompanyList!: responseDataPagination<CompanyParams>;

//   @Getter(`commerceModule/${commerce.getters.GET_NEW_COMMERCE_PARAMS}`)
//   getNewCompanyCommerce!: Array<NewCommerceParams>;

//   @Mutation(`commerceModule/${commerce.mutations.SET_NEW_COMMERCE_PARAMS}`)
//   setNewCompanyParams!: VuexFunction;

//   @Getter(`commerceModule/${commerce.getters.GET_COMMERCES}`)
//   getCommerceList!: CommerceCollectionResponse;

//   @Action(`companyModule/${company.actions.SINGLE_COMPANY}`)
//   singleCompanyAction!: VuexFunction;

//   @Getter(`companyModule/${company.getters.GET_SINGLE_COMPANY}`)
//   getSingleCompany!: CompanyParams;

//   @Action(`uploadImage/${uploadimage.actions.UPDATE_COMMERCE_BANNER}`)
//   saveImagesForCommerce!: VuexFunction;
// }
